import React from 'react'
import PropTypes from 'prop-types'
import { TASK_NOT_STARTED_PERCENT, TASK_COMPLETE_PERCENT } from '../../constants/taskConstants'

class BoardInfoLaneDescription extends React.Component {
  render() {
    return (
      <div className='lane-help-entry'>
        <div className='lane-help-lane-name'>{this.props.name}</div>
        <div className='lane-help-lane-description'>
          <div>{this.getLaneContainsText(this.props.mapping)}</div>
          {this.hasLaneSetsValue(this.props.mapping) &&
            (<div>{this.getLaneSetsText(this.props.mapping)}</div>)}
        </div>
      </div>
    )
  }

  getLaneContainsText = (mapping) => {
    let lookupKey

    if (mapping.onHold) {
      lookupKey = 'taskBoards.Text_LaneContainsOnHold'
    } else if (mapping.startPercent === TASK_NOT_STARTED_PERCENT && mapping.endPercent === TASK_NOT_STARTED_PERCENT) {
      lookupKey = 'taskBoards.Text_LaneContainsNotStarted'
    } else if (mapping.startPercent === TASK_COMPLETE_PERCENT && mapping.endPercent === TASK_COMPLETE_PERCENT) {
      lookupKey = 'taskBoards.Text_LaneContainsCompleted'
    } else if (mapping.startPercent === 0) {
      lookupKey = 'taskBoards.Text_LaneContainsZeroPlus'
    } else {
      lookupKey = 'taskBoards.Text_LaneContainsPercentRange'
    }

    return this.getLocalizedText(lookupKey, mapping)
  }

  getLaneSetsText = (mapping) => {
    let lookupKey

    if (mapping.onHold) {
      lookupKey = 'taskBoards.Text_LaneSetsOnHold'
    } else if (mapping.setPercentCompleteTo === TASK_NOT_STARTED_PERCENT) {
      lookupKey = 'taskBoards.Text_LaneSetsNotStarted'
    } else if (mapping.setPercentCompleteTo === TASK_COMPLETE_PERCENT) {
      lookupKey = 'taskBoards.Text_LaneSetsComplete'
    } else {
      lookupKey = 'taskBoards.Text_LaneSetsPercent'
    }

    return this.getLocalizedText(lookupKey, mapping)
  }

  hasLaneSetsValue = (mapping) => {
    return mapping.setPercentCompleteTo !== undefined || mapping.onHold
  }

  getLocalizedText = (key, mapping) => {
    return this.props.localize(key)
      .replace('{startPercent}', mapping.startPercent)
      .replace('{endPercent}', mapping.endPercent)
      .replace('{setPercentCompleteTo}', mapping.setPercentCompleteTo)
  }
}

BoardInfoLaneDescription.propTypes = {
  localize: PropTypes.func,
  name: PropTypes.string.isRequired,
  mapping: PropTypes.object.isRequired
}

export default BoardInfoLaneDescription



// WEBPACK FOOTER //
// ./src/components/BoardInfo/BoardInfoLaneDescription.js